export default __webpack_public_path__ + "static/media/invalid-name.4eaf23fa.png";